<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="dataForm.title" placeholder="标题"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="contact">
        <el-input v-model="dataForm.contact" placeholder="联系方式"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="dataForm.phone" placeholder="电话"></el-input>
      </el-form-item>
      <el-form-item label="问题描述" prop="question">
        <el-input v-model="dataForm.question" placeholder="问题描述"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        title: '',
        contact: '',
        phone: '',
        question: '',
        status: ''
      },
      dataRule: {
        title: [
          {required: true, message: '标题不能为空', trigger: 'blur'}
        ],
        contact: [
          {required: true, message: '联系方式不能为空', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '电话不能为空', trigger: 'blur'}
        ],
        question: [
          {required: true, message: '问题描述不能为空', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '状态不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init(id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/leaveMessage/list`),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              id: id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/leaveMessage/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || undefined,
              'title': this.dataForm.title,
              'contact': this.dataForm.contact,
              'phone': this.dataForm.phone,
              'question': this.dataForm.question,
              'status': this.dataForm.status
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.$emit('refreshDataList')
              this.visible = false
            this.$message({
              message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/helpcenter/leavemessage-add-or-update.vue